// import React, { useEffect, useState } from "react"
// import secureLocalStorage from "react-secure-storage"
// import { Row, Modal, Form } from "reactstrap"
// import Swal from "sweetalert2"
// import { fetchNodeData } from "utils/common-fetchData"
// import Select from "react-select"

// function FinalApproval({ isOpen, onClose, options }) {
//   const [empType, setEmptype] = useState(1)
//   const [empTypes, setEmptypes] = useState([])
//   const [components, setComponents] = useState([])
//   const [salarycomps, setSalarycomps] = useState({
//     earnings: [],
//     deductions: [],
//   })

//   const [salary, setSalary] = useState("")

//   const [emp_id, setEmpId] = useState("")
//   const [punch_id, setPunchId] = useState("")
//   const [date_join, setDateJoin] = useState("")
//   const [email, setEmail] = useState("")
//   const [password, setPassword] = useState("")

//   const [role_name, setRoleName] = useState("")
//   const [department, setDepartment] = useState("")
//   const [designation, setDesignation] = useState("")
//   const [swiftDec, setSwiftDec] = useState("")

//   useEffect(() => {
//     const fetchTypes = async () => {
//       try {
//         const response = await fetchNodeData(
//           false,
//           "employeeType/get",
//           secureLocalStorage.getItem("auth_token")
//         )
//         setEmptypes(response.data || [])
//       } catch (err) {
//         console.log(err)
//       }
//     }
//     fetchTypes()
//   }, [])

//   useEffect(() => {
//     const fetchComponents = async () => {
//       try {
//         const response = await fetchNodeData(
//           false,
//           "salaryComponent/get",
//           secureLocalStorage.getItem("auth_token")
//         )
//         setComponents(
//           response.data.map(item => ({
//             ...item,
//             name: item.componentName,
//             type: item.type,
//             calcType: item.calculationType,
//             value: item.value,
//             calcBase: item.calculationBase,
//             applicableFor: empTypes.find(d => d.id === item.applicableFor),
//           })) || []
//         )
//       } catch (err) {
//         console.log(err)
//       }
//     }

//     if (empTypes.length) fetchComponents()
//   }, [empTypes])

//   useEffect(() => {
//     if (components.length) {
//       setSalarycomps({
//         earnings: components.filter(
//           i => i.applicableFor.id == empType && i.type === "Earning"
//         ),
//         deductions: components.filter(
//           i => i.applicableFor.id == empType && i.type === "Deduction"
//         ),
//       })
//     }
//   }, [empType, components])

//   function calculateSalary() {}

//   async function onSubmit(e) {
//     e.preventDefault()
//     Swal.fire({
//       icon: "warning",
//       title: "Are you sure ?",
//       text: `You want to complete the onboarding process.`,
//       showCancelButton: true,
//     }).then(async willOkay => {
//       if (willOkay.isConfirmed) {
//         swal("", "Onboarding process finished!", "success")
//       }
//     })
//   }

//   console.log(JSON.stringify(components))

//   return (
//     <Modal isOpen={isOpen} size="xl" centered>
//       <Form onSubmit={onSubmit}>
//         <div className="modal-header">
//           <h5 className="modal-title mt-0">Final Approval</h5>
//           <div>
//             <button type="submit" className="border-radius btn btn-purple me-4">
//               <i className="fas fa-save me-2"></i>
//               Approve Now
//             </button>
//             <button type="button" onClick={onClose} className="btn-modal-close">
//               <span className="btn-modal-span">&times;</span>
//             </button>
//           </div>
//         </div>

//         <div className="modal-body">
//           <Row>
//             <div className="col-md-5 border-end">
//               <Row>
//                 <div className="col-md-4">
//                   <label htmlFor="">Employee Type</label>
//                   <select
//                     value={empType}
//                     onChange={e => setEmptype(e.target.value)}
//                     className="form-select"
//                   >
//                     <option value="">Select type</option>
//                     {empTypes.map(item => (
//                       <option key={item.id} value={item.id}>
//                         {item.employeetype}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="">Total Salary</label>
//                   <input
//                     type="text"
//                     value={salary}
//                     onChange={e => setSalary(e.target.value)}
//                     className="form-control"
//                     placeholder="eg. 20000"
//                   />
//                 </div>
//                 <div className="col-md-4 align-self-end pb-1">
//                   <button
//                     className="btn btn-sm btn-purple"
//                     onClick={calculateSalary}
//                   >
//                     <i className="fas fa-calculator me-1"></i> Calculate
//                   </button>
//                 </div>

//                 <div className="col-12 mt-3 pe-5">
//                   <p className="fw-semibold mb-2" style={{ color: "#16a34a" }}>
//                     <i className="fas fa-arrow-up me-1"></i>Earnings
//                   </p>
//                   <table className="table">
//                     <tbody>
//                       {salarycomps.earnings.map(item => (
//                         <tr key={item.id}>
//                           <th className="col-8">{item.componentName}</th>
//                           <td>8670</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 <div className="col-12 mt-3 pe-5">
//                   <p className="fw-semibold mb-2" style={{ color: "#dc2626" }}>
//                     <i className="fas fa-arrow-down me-1"></i>Deductions
//                   </p>
//                   <table className="table">
//                     <tbody>
//                       {salarycomps.deductions.map(item => (
//                         <tr key={item.id}>
//                           <th className="col-8">{item.componentName}</th>
//                           <td>8670</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </Row>
//             </div>

//             <div className="col-md-7">
//               <h5 className="mb-3">Details required to proceed.</h5>
//               <Row className={"p-4 bg-light"}>
//                 <div className="col-md-6 mb-3">
//                   <label htmlFor="">Role Name</label>
//                   <Select
//                     placeholder={"Select Role"}
//                     isClearable={true}
//                     className="basic-multi-select "
//                     classNamePrefix="select"
//                     options={options?.roles}
//                     value={role_name}
//                     onChange={e => setRoleName(e)}
//                   />
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   <label htmlFor="">Department</label>
//                   <Select
//                     placeholder="Select Department"
//                     isClearable={true}
//                     className="basic-multi-select "
//                     classNamePrefix="select"
//                     options={options?.departments}
//                     value={department}
//                     onChange={e => setDepartment(e)}
//                   />
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   <label htmlFor="">Designation</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Designation"
//                     className="form-control "
//                     id=""
//                     value={designation != "null" ? designation : ""}
//                     onChange={e => setDesignation(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   <label htmlFor="">Shift</label>
//                   <Select
//                     placeholder="Select Shift"
//                     className="basic-multi-select "
//                     isClearable={true}
//                     classNamePrefix="select"
//                     options={options?.swift}
//                     value={swiftDec}
//                     onChange={e => setSwiftDec(e)}
//                   />
//                 </div>

//                 <div className="col-md-4 mb-3">
//                   <label>
//                     Employee Id <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     required
//                     type="text"
//                     placeholder="e.g 99999"
//                     className="form-control"
//                     value={emp_id}
//                     onChange={e => setEmpId(e.target.value)}
//                   />
//                 </div>

//                 <div className="col-md-4 mb-3">
//                   <label>Punch Id</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Punch Id"
//                     className="form-control"
//                     value={punch_id}
//                     onChange={e => setPunchId(e.target.value)}
//                   />
//                 </div>

//                 <div className="col-md-4 mb-3">
//                   <div>
//                     <label>Date Of Joining</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={date_join}
//                       onChange={e => setDateJoin(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 {/* Email */}
//                 <div className="col-md-6 mb-3">
//                   <label>
//                     Email <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="email"
//                     placeholder="Enter Email"
//                     className="form-control"
//                     value={email}
//                     onChange={e => setEmail(e.target.value)}
//                   />
//                 </div>

//                 {/* Password */}
//                 <div className="col-md-6 mb-3">
//                   <label>
//                     Password <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="password"
//                     placeholder="Enter Password"
//                     className="form-control"
//                     value={password}
//                     onChange={e => setPassword(e.target.value)}
//                   />
//                 </div>
//               </Row>
//             </div>
//           </Row>
//         </div>
//       </Form>
//     </Modal>
//   )
// }

// export default FinalApproval

import React, { useEffect, useState } from "react"
import secureLocalStorage from "react-secure-storage"
import { Row, Modal, Form, Spinner } from "reactstrap"
import Swal from "sweetalert2"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import Select from "react-select"
import configure from "configure"
import axios from "axios"

const fixCompIds = {
  basic: 1,
  basicIntern: 16,
  da: 9,
  ma: 10,
  hra: 11,
  ca: 12,
  esi: 13,
  pt: 14,
  pf: 15,
  od: 17,
}

function FinalApproval({
  isOpen,
  onClose,
  options,
  staffId,
  setIsApproved,
  empData,
  getStaffDetails
}) {
  const [empType, setEmptype] = useState(1)
  const [empTypes, setEmptypes] = useState([])
  const [components, setComponents] = useState([])
  const [salarycomps, setSalarycomps] = useState({
    earnings: [],
    deductions: [],
  })
  const [calculatedComps, setCalculatedComps] = useState({
    earnings: [],
    deductions: [],
    totalEarnings: 0,
    totalDeductions: 0,
    netSalary: 0,
  })

  const [salary, setSalary] = useState("")
  const [emp_id, setEmpId] = useState("")
  const [punch_id, setPunchId] = useState("")
  const [date_join, setDateJoin] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [role_name, setRoleName] = useState("")
  const [department, setDepartment] = useState("")
  const [designation, setDesignation] = useState("")
  const [swiftDec, setSwiftDec] = useState("")
  const [loading, setLoading] = useState("")

  useEffect(() => {
    if (isOpen) {
      setRoleName(
        options.roles?.find(i => i.value == empData?.role_name?.value)
      )
      setDepartment(
        options.departments?.find(i => i.value == empData?.department?.value)
      )
      setDesignation(empData.designation)
      setSwiftDec(options.swift?.find(i => i.value == empData?.swiftDec?.value))
      setEmpId(empData.emp_id)
      setPunchId(empData.punch_id)
      setDateJoin(empData.date_join)
      setEmail(empData.email)
      setSalary(empData.totalSalary)
      if (empData.totalSalary) calculateSalary(null, empData.totalSalary)
    }
  }, [isOpen])

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const response = await fetchNodeData(
          false,
          "employeeType/get",
          secureLocalStorage.getItem("auth_token")
        )
        setEmptypes(response.data || [])
      } catch (err) {
        console.log(err)
      }
    }
    fetchTypes()
  }, [])

  useEffect(() => {
    const fetchComponents = async () => {
      try {
        const response = await fetchNodeData(
          false,
          "salaryComponent/get",
          secureLocalStorage.getItem("auth_token")
        )
        setComponents(
          response.data.map(item => ({
            ...item,
            name: item.componentName,
            type: item.type,
            calcType: item.calculationType,
            value: item.value,
            calcBase: item.calculationBase,
            applicableFor: empTypes.find(d => d.id === item.applicableFor),
          })) || []
        )
      } catch (err) {
        console.log(err)
      }
    }
    if (empTypes.length) fetchComponents()
  }, [empTypes])

  // Reset calculated comps whenever empType or salary changes
  useEffect(() => {
    if (components.length) {
      setSalarycomps({
        earnings: components.filter(
          i => i.applicableFor?.id == empType && i.type === "Earning"
        ),
        deductions: components.filter(
          i => i.applicableFor?.id == empType && i.type === "Deduction"
        ),
      })
      // Clear previous calculation when type changes
      setCalculatedComps({
        earnings: [],
        deductions: [],
        totalEarnings: 0,
        totalDeductions: 0,
        netSalary: 0,
      })
    }
  }, [empType, components])

  function calculateSalary(e, sal) {
    e?.preventDefault() // prevent accidental form submit if inside form

    const ctc = parseFloat(sal || salary)
    if (!ctc || isNaN(ctc) || ctc <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Salary",
        text: "Please enter a valid total salary before calculating.",
      })
      return
    }

    // Resolve Basic Pay amount first (needed for "Basic" base calculations)
    const basicComp = salarycomps.earnings.find(
      i => i.componentName === "Basic Pay"
    )
    const basicAmount =
      basicComp?.calcType === "Percentage" && basicComp?.calcBase === "CTC"
        ? (basicComp.value / 100) * ctc
        : basicComp?.calcType === "Fixed"
          ? basicComp.value
          : 0

    const resolveAmount = item => {
      if (item.calcType === "Percentage") {
        if (item.calcBase === "CTC") return (item.value / 100) * ctc
        if (item.calcBase === "Basic") return (item.value / 100) * basicAmount
      }
      if (item.calcType === "Fixed") return item.value
      return 0
    }

    const calculatedEarnings = salarycomps.earnings.map(item => ({
      ...item,
      amount: resolveAmount(item),
    }))

    const calculatedDeductions = salarycomps.deductions.map(item => ({
      ...item,
      amount: resolveAmount(item),
    }))

    const totalEarnings = calculatedEarnings.reduce(
      (sum, i) => sum + i.amount,
      0
    )
    const totalDeductions = calculatedDeductions.reduce(
      (sum, i) => sum + i.amount,
      0
    )
    const netSalary = totalEarnings - totalDeductions

    setCalculatedComps({
      earnings: calculatedEarnings,
      deductions: calculatedDeductions,
      totalEarnings,
      totalDeductions,
      netSalary,
    })
  }

  const fmt = amount =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount)

  function getAmount(cid, type = "earnings") {
    return calculatedComps[type]?.find(i => i.id === cid)?.amount || 0
  }

  async function onSubmit(e) {
    e.preventDefault()
    if (!calculatedComps.netSalary) {
      return swal("", "Please provide salary details.", "warning")
    }
    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: `You want to send approval request.`,
      showCancelButton: true,
    }).then(async willOkay => {
      if (willOkay.isConfirmed) {
        setLoading(true)

        const token = localStorage.getItem("auth_token") // adjust if different

        const payload = {
          id: staffId,
          basicPay: empType == 2 ? getAmount(fixCompIds.basicIntern) : getAmount(fixCompIds.basic),
          da: getAmount(fixCompIds.da),
          ma: getAmount(fixCompIds.ma),
          hra: getAmount(fixCompIds.hra),
          ca: getAmount(fixCompIds.ca),
          esi: getAmount(fixCompIds.esi, "deductions"),
          pt: getAmount(fixCompIds.pt, "deductions"),
          pf: getAmount(fixCompIds.pf, "deductions"),
          od: getAmount(fixCompIds.od, "deductions"),

          role: role_name.value,
          department: department.value,
          designation: designation,
          shift: swiftDec?.value || 0,
          empId: emp_id,
          emp_type: empType,
          punchId: punch_id,
          joinDate: date_join,
          email: email,
        }

        try {
          const apiRes = await FetchNodePostData(
            false,
            "employeeJoining/sendForApproval",
            token,
            payload
          )

          if (apiRes?.data?.success) {
            localStorage.setItem("roleId", role_name.value)
            onClose()
            setIsApproved(2)

            Swal.fire({
              icon: "success",
              text: "Request sent for approval.",
            }).then(() => {
              getStaffDetails()
            })
          }
          setLoading(false)
        } catch (err) {
          console.log(err)
          setLoading(false)
        }
      }
    })
  }

  const hasCalculation = calculatedComps.earnings.length > 0

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <Form onSubmit={onSubmit}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Final Approval</h5>
          <div>
            <button
              type="submit"
              disabled={loading}
              className="border-radius btn btn-purple me-4"
            >
              {loading ? (
                <Spinner size="sm" className="me-2" />
              ) : (
                <i className="fas fa-save me-2"></i>
              )}
              Send for approval
            </button>
            <button type="button" onClick={onClose} className="btn-modal-close">
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
        </div>

        <div className="modal-body">
          <Row>
            {/* ── LEFT PANEL: Salary Breakdown ── */}
            <div className="col-md-5 border-end">
              <Row>
                <div className="col-md-4">
                  <label>Employee Type</label>
                  <select
                    value={empType}
                    onChange={e => setEmptype(e.target.value)}
                    className="form-select"
                  >
                    <option value="">Select type</option>
                    {empTypes.map(item => (
                      <option key={item.id} value={item.id}>
                        {item.employeetype}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label>Total Salary (CTC)</label>
                  <input
                    type="number"
                    value={salary}
                    onChange={e => setSalary(e.target.value)}
                    className="form-control"
                    placeholder="e.g. 20000"
                    min={0}
                  />
                </div>

                <div className="col-md-4 align-self-end pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-purple"
                    onClick={calculateSalary}
                  >
                    <i className="fas fa-calculator me-1"></i> Calculate
                  </button>
                </div>

                {/* Earnings Table */}
                <div className="col-12 mt-3 pe-5">
                  <p className="fw-semibold mb-2" style={{ color: "#16a34a" }}>
                    <i className="fas fa-arrow-up me-1"></i>Earnings
                  </p>
                  <table className="table table-sm">
                    <tbody>
                      {salarycomps.earnings.map(item => {
                        const calc = hasCalculation
                          ? calculatedComps.earnings.find(c => c.id === item.id)
                          : null
                        return (
                          <tr key={item.id}>
                            <th className="col-8 fw-normal">
                              {item.componentName}
                              <small className="text-muted ms-1">
                                (
                                {item.calcType === "Fixed"
                                  ? "Fixed"
                                  : `${item.value}% of ${item.calcBase}`}
                                )
                              </small>
                            </th>
                            <td className="text-end">
                              {calc ? (
                                <span className="text-success fw-semibold">
                                  {fmt(calc.amount)}
                                </span>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                    {hasCalculation && (
                      <tfoot>
                        <tr className="table-success">
                          <th>Total Earnings</th>
                          <th className="text-end">
                            {fmt(calculatedComps.totalEarnings)}
                          </th>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>

                {/* Deductions Table */}
                <div className="col-12 mt-3 pe-5">
                  <p className="fw-semibold mb-2" style={{ color: "#dc2626" }}>
                    <i className="fas fa-arrow-down me-1"></i>Deductions
                  </p>
                  <table className="table table-sm">
                    <tbody>
                      {salarycomps.deductions.map(item => {
                        const calc = hasCalculation
                          ? calculatedComps.deductions.find(
                            c => c.id === item.id
                          )
                          : null
                        return (
                          <tr key={item.id}>
                            <th className="col-8 fw-normal">
                              {item.componentName}
                              <small className="text-muted ms-1">
                                (
                                {item.calcType === "Fixed"
                                  ? "Fixed"
                                  : `${item.value}% of ${item.calcBase}`}
                                )
                              </small>
                            </th>
                            <td className="text-end">
                              {calc ? (
                                <span className="text-danger fw-semibold">
                                  {fmt(calc.amount)}
                                </span>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                    {hasCalculation && (
                      <tfoot>
                        <tr className="table-danger">
                          <th>Total Deductions</th>
                          <th className="text-end">
                            {fmt(calculatedComps.totalDeductions)}
                          </th>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>

                {/* Net Salary Summary */}
                {hasCalculation && (
                  <div className="col-12 pe-5">
                    <div
                      className="rounded p-2 d-flex justify-content-between align-items-center"
                      style={{
                        backgroundColor: "#f0fdf4",
                        border: "1px solid #bbf7d0",
                      }}
                    >
                      <span className="fw-bold">Net Monthly Salary</span>
                      <span
                        className="fw-bold fs-5"
                        style={{ color: "#15803d" }}
                      >
                        {fmt(calculatedComps.netSalary)}
                      </span>
                    </div>
                  </div>
                )}
              </Row>
            </div>

            {/* ── RIGHT PANEL: Employee Details ── */}
            <div className="col-md-7">
              <h5 className="mb-3">Details required to proceed.</h5>
              <Row className="p-4 bg-light">
                <div className="col-md-6 mb-3">
                  <label>Role Name</label>
                  <Select
                    placeholder="Select Role"
                    isClearable
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={options?.roles}
                    value={role_name}
                    onChange={e => setRoleName(e)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Department</label>
                  <Select
                    placeholder="Select Department"
                    isClearable
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={options?.departments}
                    value={department}
                    onChange={e => setDepartment(e)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Designation</label>
                  <input
                    type="text"
                    placeholder="Enter Designation"
                    className="form-control"
                    value={designation !== "null" ? designation : ""}
                    onChange={e => setDesignation(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Shift</label>
                  <Select
                    placeholder="Select Shift"
                    isClearable
                    className="basic-multi-select"
                    classNamePrefix="select"
                    options={options?.swift}
                    value={swiftDec}
                    onChange={e => setSwiftDec(e)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>
                    Employee Id <span className="text-danger">*</span>
                  </label>
                  <input
                    required
                    type="text"
                    placeholder="e.g 99999"
                    className="form-control"
                    value={emp_id}
                    onChange={e => setEmpId(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Punch Id</label>
                  <input
                    type="text"
                    placeholder="Enter Punch Id"
                    className="form-control"
                    value={punch_id}
                    onChange={e => setPunchId(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label>Date Of Joining</label>
                  <input
                    type="date"
                    className="form-control"
                    value={date_join}
                    onChange={e => setDateJoin(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>
                    Work Email <span className="text-danger">*</span>
                  </label>
                  <input
                    required
                    type="email"
                    placeholder="Enter Email"
                    className="form-control"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
                {/* 
                <div className="col-md-6 mb-3">
                  <label>
                    Password <span className="text-danger">*</span>
                  </label>
                  <input
                    required
                    type="password"
                    placeholder="Enter Password"
                    className="form-control"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                </div> */}
              </Row>
            </div>
          </Row>
        </div>
      </Form>
    </Modal>
  )
}

export default FinalApproval
